module.exports = __webpack_public_path__ + "static/media/sports_7.883f35d7.jpg";